import React, { useContext, useState } from "react";
import { Dropdown } from "./dynamicMenuDatas/Dropdown";
import { Link } from "react-router-dom";
import ClickOutHandler from "react-clickout-handler";
import { UserContext } from "./Context/UserContext";

export const SmallDeviceHeaderMasterDropdown = ({ selectedMenu, setSelectedMenu }) => {
  const {setIsHeaderMenuOpen} = useContext(UserContext)
  const [isMenuOpen, setIsMenuOpen] = useState(
    Array(Dropdown.length).fill(false)
  );

  // Handle selecting a main menu item
  const handleMenuClick = (menuItem) => {
    // setSelectedMenu(null)
    setSelectedMenu(menuItem);
  };
  function menuOpenCloseHandler(index) {
    const newOpenMenus = isMenuOpen.map((isOpen, i) =>
      i === index ? !isOpen : false
    );
    setIsMenuOpen(newOpenMenus);
  }
  function outClickFun() {
    setIsMenuOpen(Array(Dropdown.length).fill(false));
  }

  return (
    <React.Fragment>
      <ClickOutHandler onClickOut={() => outClickFun()}>
        {Dropdown.map((menu, indexing) => (
            <div key={indexing} className="">
              {/* Dropdown menu */}
              <div className="">
                <ol className="px-1 relative">
                  <button
                    className={
                      "font-bold rounded cursor-pointer text-[16px] text-white active:bg-gray-400 hover:bg-red-700 py-0.5 px-2"
                    }
                    onClick={() => menuOpenCloseHandler(indexing)}
                  >
                    {menu.label}
                  </button>
                  <div className="bg-gray-200 min-w-40 rounded absolute z-50 top-9">
                    {isMenuOpen[indexing] &&
                      menu.dropdownMenu.map((item, indexes) => (
                        <Link
                          key={item.id}
                          to={item.path}
                          // onClick={() => menuOpenCloseHandler(indexes)}
                          style={{ textDecoration: "none" }}
                        >
                          <li
                            className="py-1 px-3 hover:bg-blue-600 hover:text-white text-black rounded font-medium"
                            onClick={async () => {
                              setIsHeaderMenuOpen(false);
                              // setSelectedMenu(null);
                              handleMenuClick(item);
                              setIsMenuOpen(Array(Dropdown.length).fill(false));
                            }}
                          >
                            <span onClick={() => outClickFun()}>
                              {item.label}
                            </span>
                          </li>
                        </Link>
                      ))}
                  </div>
                </ol>
              </div>

              {/* Submenu for the selected menu */}

              {/* Close- Submenu*/}
            </div>
        ))}
      </ClickOutHandler>
    </React.Fragment>
  );
};
